import { Context, CustomQuery } from '@vue-storefront/core';
import { Wishlist, WishlistItem, ApiResult } from '../../types';

export default async function wishList({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/fav/list', config.api.url);
  // const { data } = await client.post(url.href, { page: 1, limit: params.limit });
  // return data;
  const { data: res } = await client.post(url.href, { page: 1, limit: params.limit || 10 });
  if (res.code === 0) {
    const data = res.data;
    const wishList: Wishlist = {
      list: [],
      total: data.total_count,
      page: data.page,
      limit: data.limit
    };

    if (data && data.list) {
      // 循环list
      data.list.forEach((x) => {
        const address: WishlistItem = {
          favId: x.fav_id,
          goodId: x.good_id,
          skuId: x.sku_id,
          goods: x.goods,
          sku: x.sku,
        };
        wishList.list.push(address);
      });
    }
    res.data = wishList;
  }
  return res;
}
